exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-with-caption img{width:100%}.image-with-caption img:not(.no-margin){margin-bottom:0}.image-with-caption span{font-size:1rem;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/image-with-caption/image-with-caption.styl
// module id = 499
// module chunks = 0